import axios from "axios";
import config from "@/router/globalConfig";
export default {
    getCountry(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetCountry', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    getTitle(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetTitle', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    DownloadBrochure(_data_) {
        return axios.post(config.WEB_API_PATH + 'AllMaster/v1/DownloadBrochure', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    GetBank(_data_) {//GetBankListAutoComplete
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetBankList', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetBankListAutoComplete(_data_) {//GetBankListAutoComplete
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetBankListAutoComplete', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetDesigListAutoComplete(_data_) {//GetBankListAutoComplete
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetDesigListAutoComplete', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetDesigList(_data_) {//GetBankListAutoComplete
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetDesigList', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/AllMasterJS.js